<template>
    <router-link
        v-if="!notVisibleByPermission"
        :to="route"
        :class="{
            'is-active': isActive,
            'is-not-allowed': locked && !canViewAdministratively,
        }"
        class="is-align-center is-space-between p-r-none"
        :title="titleText"
        @click="closeMenu"
    >
        <span class="tw:inline-flex tw:items-center">
            <span style="word-wrap: break-word; white-space: normal">{{ item.text }}</span>
            <span
                v-if="isActive"
                class="active-dot tw:inline-block tw:min-w-2 tw:min-h-2 tw:bg-[var(--primary-color)]! tw:rounded-full tw:ml-2 tw:flex-shrink-0"
            />
        </span>

        <e-icon v-if="completed" icon="check" />

        <locked-item
            v-if="locked"
            :item="{
                type: locked && hasPrerequisite ? 'prerequisite' : 'visibleAt',
                prereqTitle: locked && hasPrerequisite ? prereqTitle : null,
                namespace: item.type,
                visibleAt: titleText,
                position: 'is-right',
            }"
        />

        <unlocked-item
            v-if="unlocked"
            :item="{
                type: hasPrerequisite ? 'prerequisite' : 'visibleAt',
                prereqTitle: hasPrerequisite ? prereqTitle : null,
                namespace: item.type,
                visibleAt: titleText,
                position: 'is-right',
            }"
        />
    </router-link>
</template>

<script>
import has from 'lodash/has.js';

import LockedItem from '@/components/nested-list/LockedItem.vue';
import UnlockedItem from '@/components/nested-list/UnlockedItem.vue';
import ActiveStatusMixin from '@/mixins/ActiveStatus.mixin.js';
import SidebarMixin from '@/mixins/Sidebar.mixin.js';

export default {
    name: 'NestedActivity',

    components: { LockedItem, UnlockedItem },

    mixins: [ActiveStatusMixin, SidebarMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },
    },

    emits: ['expand'],

    computed: {
        route() {
            if (this.locked && !this.canViewAdministratively) return {};

            if (!has(this.item, 'course_id') || !has(this.item, 'activity_id')) {
                throw new Error(
                    `Course id must be present on the item that is passed to <activity>. Received: ${JSON.stringify(
                        this.item
                    )}`
                );
            }

            return {
                name: 'activity-view',
                params: {
                    courseId: this.item.course_id,
                    activityId: this.item.activity_id,
                },
            };
        },

        completed() {
            if (!this.$store.getters['Activities/has'](this.item.uuid)) {
                return this.item.completed;
            }

            return this.$store.getters[`Activities/${this.item.uuid}/get`]('completed');
        },
    },

    created() {
        if (this.isActive) {
            this.$emit('expand', this.item.uuid);
        }
    },
};
</script>
